import script from "./Product.vue?vue&type=script&setup=true&lang=js"
export * from "./Product.vue?vue&type=script&setup=true&lang=js"

import "./Product.vue?vue&type=style&index=0&id=2f775536&lang=css"

const __exports__ = script;

export default __exports__